module.exports = require("i18next-xhr-backend");